import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=45fd1382&scoped=true"
import script from "./OverviewTab.vue?vue&type=script&lang=ts"
export * from "./OverviewTab.vue?vue&type=script&lang=ts"
import style0 from "./OverviewTab.vue?vue&type=style&index=0&id=45fd1382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd1382",
  null
  
)

export default component.exports